(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Booker", [], factory);
	else if(typeof exports === 'object')
		exports["Booker"] = factory();
	else
		root["Booker"] = factory();
})(self, () => {
return 